var _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasolinePump({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "42.52px",
    height: "28.35px",
    viewBox: "0 0 42.52 28.35",
    enableBackground: "new 0 0 42.52 28.35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.51,16.241l-0.117,4.252c0,0.473,0.354,0.827,0.826,0.827s0.826-0.354,0.826-0.827l0.06-4.192L25.51,16.241z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.802,22.148l-2.244-3.426l0.591-2.657l-2.953-0.118l0,0c-0.236,0.886-0.059,1.89,0.472,2.657l2.834,4.37 c0.827,1.24,2.244,1.89,3.721,1.654l2.953-0.473l0.059-1.595l-3.248,0.531C26.101,23.21,25.273,22.856,24.802,22.148z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.604,
    y: 23.502,
    transform: "matrix(-0.2065 -0.9784 0.9784 -0.2065 14.3693 63.1448)",
    width: 4.37,
    height: 4.487
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.195,2.6c-0.236-0.236-0.532-0.413-0.886-0.473l-8.268-2.126l-0.886,3.603l7.795,2.008l3.071,3.012l2.658-2.599 L20.195,2.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.345,18.333l1.358,6.438c0.059,0.295,0.354,0.471,0.649,0.412l4.429-0.885c0.296-0.061,0.473-0.355,0.414-0.65 l-1.004-4.666c0.768-0.354,1.182-1.24,0.768-2.066l-3.248-6.673c-0.826-1.653-2.834-2.362-4.488-1.535l0,0l-3.661-3.603 c-0.236-0.236-0.649-0.236-0.886,0l-2.717,2.717l-0.118,1.063c-0.354,2.835-0.236,5.729,0.354,8.563l0,0L28.345,18.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.581,15.497c0,1.832-1.477,3.309-3.248,3.309c-1.772,0-3.248-1.477-3.248-3.309c0-1.83,3.248-6.496,3.248-6.496 S13.581,13.667,13.581,15.497z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.333,17.778c-1.24,0-2.244-1.004-2.244-2.304c0-0.236,0.177-0.413,0.413-0.413s0.414,0.177,0.414,0.413 c0,0.827,0.649,1.477,1.417,1.477c0.236,0,0.413,0.177,0.413,0.413S10.569,17.778,10.333,17.778z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M12.459,26.163c0,1.24-0.945,2.185-2.126,2.185c-1.181,0-2.126-1.004-2.126-2.185 c0-1.24,2.126-4.252,2.126-4.252S12.459,24.923,12.459,26.163z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.333,27.64c-0.827,0-1.477-0.65-1.477-1.536c0-0.177,0.118-0.295,0.295-0.295 c0.177,0,0.295,0.118,0.295,0.295c0,0.532,0.414,0.945,0.945,0.945c0.118,0,0.295,0.118,0.295,0.295 C10.569,27.522,10.451,27.64,10.333,27.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolinePump);
export default __webpack_public_path__ + "static/media/gasoline-pump.ce932b1399c3eff18a79619ded34d922.svg";
export { ForwardRef as ReactComponent };